import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import "./settings-modern.css";

function ChangeBioModal({ open, handleClose, user, admin }) {
  const [invalid, setInvalid] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    setInvalid(false);
    const data = new FormData(e.currentTarget);
    const bio = (data.get("bio") || "").trim();
    if (bio.length < 3) { setInvalid(true); return; }

    const request = admin === "yes"
      ? axios.put(`${process.env.React_APP_BACKEND_URL}/api/admin/changebio`, { bio, id: user.id }, { headers: { Authorization: `Bearer ${Cookies.get("admintoken")}` } })
      : axios.put(`${process.env.React_APP_BACKEND_URL}/api/changebio`, { bio }, { headers: { Authorization: `Bearer ${Cookies.get("token")}` } });

    request.then(() => {
      if (admin !== "yes") Cookies.set("bio", bio, { expires: 365 });
      handleClose("bio");
    }).catch((err) => console.log(err));
  };

  return (
    <Modal open={open} onClose={() => handleClose("bio")} aria-labelledby="change-bio-title">
      <Box className="bidit-settings-modal">
        <Box className="bidit-settings-head">
          <Typography id="change-bio-title" className="bidit-settings-title">עדכון "קצת על עצמי"</Typography>
          <Typography className="bidit-settings-subtitle">כמה מילים קצרות שיעזרו למשתמשים להכיר אתכם טוב יותר.</Typography>
        </Box>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField required fullWidth multiline minRows={4} name="bio" defaultValue={user?.bio || ""} placeholder="כתבו כאן כמה מילים..." />
          {invalid && <Box className="bidit-settings-error">יש להזין לפחות 3 תווים.</Box>}
          <Button fullWidth type="submit" variant="contained" className="bidit-settings-primary" sx={{ mt: 2.5 }}>שמירת השינויים</Button>
        </Box>
      </Box>
    </Modal>
  );
}
export default ChangeBioModal;
